import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/** Reusable SERP wordmark logo (PNG w/ transparent bg). */
export function SerpLogo({ height = 32, className = "", testid = "serp-logo", inverted = false }) {
  return (
    <img
      src="/serp-logo-transparent.png"
      alt="SERP"
      data-testid={testid}
      className={className}
      style={{
        height, width: "auto", display: "block",
        objectFit: "contain", flexShrink: 0,
        imageRendering: "-webkit-optimize-contrast",
        filter: inverted ? "brightness(0) invert(1)" : "none",
      }}
      draggable={false}
    />
  );
}

const NAV_LINKS = [
  { id: "about",    label: "About" },
  { id: "product",  label: "Product" },
  { id: "features", label: "Features" },
  { id: "how",      label: "How it works" },
  { id: "workflow", label: "Workflow" },
  { id: "pricing",  label: "Pricing" },
  { id: "resources",label: "Resources" },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const scrollTo = (id) => (e) => {
    if (typeof window !== "undefined" && document.getElementById(id)) {
      e.preventDefault();
      document.getElementById(id).scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      navigate(`/#${id}`);
    }
  };
  return (
    <header
      className="sticky top-0 z-40 border-b bg-white"
      data-testid="site-header"
      style={{ borderColor: "#E5E7EB", height: 72 }}
    >
      <div className="max-w-7xl mx-auto h-full px-6 lg:px-10 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center h-full" data-testid="site-header-brand">
          <SerpLogo height={40} testid="site-header-logo"/>
        </Link>

        <nav className="hidden lg:flex items-center gap-6" data-testid="site-header-nav">
          {NAV_LINKS.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              onClick={scrollTo(l.id)}
              data-testid={`site-nav-${l.id}`}
              className="text-[13px] tracking-wide text-[#4B5563] hover:text-[#FF5500] font-medium transition-colors"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/login"
            data-testid="site-header-cta-login"
            className="hidden md:inline-flex items-center h-9 px-4 text-[#1C1C1C] hover:text-[#FF5500] text-[13px] font-semibold transition-colors"
          >
            Login
          </Link>
          <Link
            to="/register"
            data-testid="site-header-cta-register"
            className="inline-flex items-center gap-1.5 h-9 px-4 bg-[#FF5500] hover:bg-[#E64A00] text-white text-[13px] font-semibold rounded-md transition-colors"
          >
            Create Account <ArrowRight size={14}/>
          </Link>
        </div>
      </div>
    </header>
  );
}
